import { render, staticRenderFns } from "./DadosCertificado.vue?vue&type=template&id=25666c8b&"
import script from "./DadosCertificado.vue?vue&type=script&lang=js&"
export * from "./DadosCertificado.vue?vue&type=script&lang=js&"
import style0 from "./DadosCertificado.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports